import React, { useCallback, useEffect, useState } from 'react'
import { ScrollTopButtonText, ScrollTopButtonWrap } from './index.styled'
import { useTranslation } from 'react-i18next'
import MainIcon from '../../../../img/svg/main'

const ScrollTopButton = React.memo(({ visibleHeight = 250 }) => {
	const [visible, setVisible] = useState(false)
	const { t } = useTranslation()
	const layout = visible ? 'lf-visible ' : ''

	const toggleVisible = () => {
		const contentBlock = document.getElementById('content')
		const contentScrollTop = contentBlock.scrollTop
		if (contentScrollTop > visibleHeight && !visible) {
			setVisible(true)
		} else if (contentScrollTop <= visibleHeight && visible) {
			setVisible(false)
		}
	}

	useEffect(() => {
		const contentBlock = document.getElementById('content')
		contentBlock.addEventListener('scroll', toggleVisible)
		return () => {
			contentBlock.removeEventListener('scroll', toggleVisible)
		}
	}, [visible]) // eslint-disable-line react-hooks/exhaustive-deps

	const scrollToTop = useCallback(() => {
		const contentBlock = document.getElementById('content')
		contentBlock.scrollTo({
			top: 0,
			behavior: 'smooth',
		})
	}, [])

	return (
		<ScrollTopButtonWrap className={layout} onClick={scrollToTop}>
			<MainIcon icon="arrow-up" />
			<ScrollTopButtonText>{t('buttons.scrollButton')}</ScrollTopButtonText>
		</ScrollTopButtonWrap>
	)
})

ScrollTopButton.displayName = 'ScrollTopButton'
export default ScrollTopButton
